var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-8"},[_c('base-title',{staticClass:"pl-2 text-uppercase",attrs:{"title":_vm.title,"size":"subtitle-2","space":"2"}}),_c('v-progress-linear',{attrs:{"value":_vm.value,"background-color":"grey lighten-2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }